import styled from "@emotion/styled";

export const TitleContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  text-overflow: ellipsis;
  white-space: break-spaces;
`;

export const TitleContentsOverflowWrapper = styled(TitleContentsWrapper)`
  max-height: 82px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const Image = styled.img(
  ({ width, height }) => `
  width: ${width || "64px"};
  height: ${height || "64px"};
  display: block;
  background-repeat: no-repeat;
  background-position: 50%;
  cursor: pointer;
`
);

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  &.tooltip-image {
    max-width: 180px;
    max-height: 180px;
    overflow: hidden;
  }
`;
